import * as yup from "yup";
const currentYear = new Date().getFullYear();

export const propertySchema = yup.object({
  // 1. basicPropertyInformation:
  propertyType: yup.string().required("Property Type is required"),
  propertyAddress: yup.string().required("Property Address is required"),
  listingPrice: yup.string().required("Listing Price is required"),
  squareFootage: yup.string().required("Square Footage is required"),
  numberofBedrooms: yup.number().required("Number Of Bedrooms is required"),
  numberofBathrooms: yup.number().required("Number Of Bathrooms is required"),
  yearBuilt: yup
    .number()
    .min(1000)
    .max(currentYear)
    .required("Year Built is required"),
  propertyDescription: yup
    .string()
    .required("Property Description is required"),
  //2. Property Features and Amenities:
  lotSize: yup.string(),
  parkingAvailability: yup.string(),
  appliancesIncluded: yup.string(),
  heatingAndCoolingSystems: yup.string(),
  flooringType: yup.string(),
  exteriorFeatures: yup.string(),
  communityAmenities: yup.string(),
  //3. Media and Visuals:
  propertyPhotos: yup.array(),
  virtualToursOrVideos: yup.array(),
  floorPlans: yup.array(),
  propertyDocuments: yup.array(),
  //4. Listing and Marketing Details:
  listingStatus: yup.string(),
  listingAgentOrTeam: yup.string(),
  listingDate: yup.string(),
  marketingDescription: yup.string(),
  multipleListingService: yup.string(),
  //5. Property History:
  previousOwners: yup.number().min(0).notRequired(),
  purchaseHistory: yup.string(),
  //6. Financial Information:
  propertyTaxes: yup.string(),
  homeownersAssociation: yup.string(),
  mortgageInformation: yup.string(),
  //7. Contacts Associated with Property:
  sellers: yup.string(),
  buyers: yup.string(),
  propertyManagers: yup.string(),
  contractorsOrServiceProviders: yup.string(),
  //8. Property Notes and Comments:
  internalNotesOrComments: yup.string(),
});
